export const ROOT_PATH = '/home/student';
export const AVATAR_BUILDER_PATH = `${ROOT_PATH}/avatar-builder`;
